import React, { useCallback, useMemo } from 'react'
import { useSelector, shallowEqual } from 'react-redux'

import * as gameSelectors from '../game.selectors'
import * as selectors from './popups.selectors'

const PopupsContainer = () => {
  // Redux selectors optimizados
  const popupData = useSelector(
    (state) => ({
      popups: selectors.getPopups(state),
      components: gameSelectors.getModuleComponents(state),
    }),
    shallowEqual
  )

  const { popups, components } = popupData

  /**
   *  Render each popup available
   */
  const renderPopup = useCallback((popup) => {
    const Popup = components[popup.component]

    if (!Popup) {
      throw new Error(`${popup.component} cannot be found. Check if the module has registered it.`)
    }

    const popupStyle = { ...popup.style }
    const popupProps = { ...popup.props, style: popupStyle }

    return <Popup key={popup.id} {...popupProps} />
  }, [components])

  // Renderizado condicional al final
  if (popups.length === 0) {
    return null
  }

  return (
    <div className={'popups-container ' + popups[0].addContainerClass}>
      {popups.map((popup) => renderPopup(popup))}
    </div>
  )
}

export default React.memo(PopupsContainer)
